module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kanban-container"
  }, _vm._l((_vm.stages), function(stage) {
    return _c('div', {
      key: stage.value,
      staticClass: "kanban-region elevation-3"
    }, [_c('div', {
      staticClass: "pa-2",
      staticStyle: {
        "background-color": "#eee",
        "border-radius": "5px",
        "font-weight": "600",
        "color": "#666"
      }
    }, [_vm._v("\n            " + _vm._s(stage.text) + " \n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pa-2 kanban-body"
    }, [_c('div', {
      staticClass: "kanban-counter"
    }, [_vm._v(_vm._s(_vm.getItemsForRegion(stage.value).length))]), _vm._v(" "), _c('draggable', {
      key: stage.value,
      staticClass: "draggable-container",
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "min-height": "200px"
      },
      attrs: {
        "data-stage": stage.value,
        "data-stage-text": stage.text,
        "options": {
          animation: 350,
          group: 'kanban',
          xxxhandle: '.menu-icon'
        }
      },
      on: {
        "end": _vm.afterDrag
      }
    }, _vm._l((_vm.getItemsForRegion(stage.value)), function(item) {
      return _c('div', {
        key: _vm.getItemId(item),
        attrs: {
          "data-id": _vm.getItemId(item)
        },
        on: {
          "click": function($event) {
            return _vm.itemClicked(item)
          }
        }
      }, [_vm._t("default", [_c('div', {
        staticClass: "kanban-item hoverable clickable"
      }, [_vm._v("\n                    " + _vm._s(item.clients) + " "), _c('span', {
        staticClass: "light-text"
      }, [_vm._v(_vm._s(item.title))]), _vm._v("asdfasdf\n                    ")])], {
        "item": item
      })], 2)
    }), 0)], 1)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e92f24a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/KanbanView.vue
// module id = 2448
// module chunks = 1